/*
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-05-08 23:02:46
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-06 21:39:25
 * @FilePath: \vue-privilege-routing\src\router\permission.js
 */
import router from "./index"
import store from "../store/index"

router.beforeEach((to,from,next) =>{
    
    if(!store.state.UserToken){
        // 未登录  页面是否需要登录
        if(to.matched.length > 0 && !to.matched.some(record => record.meta.requiresAuth)){
            next();
        }else{
            next({
                path:"/website"
            })
        }
    }else{
        
        // 用户已经登录  路由的访问权限
        if(!store.state.permission.permissionList){
            
            store.dispatch("permission/FETCH_PERMISSION").then(() =>{
                next({
                    path:to.path
                })
            })
        }else{
            
            // store存在权限
            if(to.path !== "/login"){
                next();
            }else{
                next(from.fullPath)
            }
        }
    }
})